import { Injectable } from '@angular/core';
import { HttpService } from '../../utils/services/http.service';
import { Observable } from 'rxjs/Observable';
import { SessionStorage } from 'ngx-webstorage';
import { ErrorsService } from '../../utils/services/errors.service';

@Injectable()
export class DashboardEmployeeService {
  @SessionStorage() public user;
  public selectedrow: any;
  constructor(private httpService: HttpService,
    private errorsService: ErrorsService) { }

  /**function to set selected row */
  public setSelectedRowData(data, weekNumber, year) {
    this.selectedrow = { 'data': data, 'weekNumber': weekNumber, 'year': year };
  }

  /**function to return selected row */
  public getSelectedRowData() {
    return this.selectedrow;
  }

  /**function to get employee details */
  getEmployeesDetails(): Observable<any> {
    const data = {
      'userDetails': {
        'EmailID': this.user.EmailID,
        'Empname': this.user.Empname,
        'Empno': this.user.Empno,
      }
    };
    return this.httpService.post(`employee/dashboard`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**function to submit unlock requested  */
  submitRequestUnlock(comments): Observable<any> {
    const data = {
      'empno': this.user.Empno,
      'comment': comments
    };
    return this.httpService.post(`employee/requestUnlock`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**function to get unlock status */
  getLockedStatus(): Observable<any> {
    return this.httpService.get(`employee/lock/status`)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**function to get timesheet entry details */
  getCalendarPendingTimesheets(data): Observable<any> {
    return this.httpService.get(`pending-timesheets?month=${data.month}&year=${data.year}`)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }
  
  /**function to handle error response */
  handleError(error: any) {
    this.errorsService.handleError(error);
    return Observable.throw(error.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/employee/dashboard-employee/dashboard-employee.service.ts